<!-- src/components/views/components/CellRenderer.vue -->
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { useCellRenderers } from '@/composables/useCellRenderers';

export default defineComponent({
  name: 'CellRenderer',
  props: {
    moduleName: { type: String, required: true },
    header: { type: Object as PropType<any>, required: true },
    item:   { type: Object as PropType<any>, required: true },
  },
  setup(props) {
    const { renderCell } = useCellRenderers(props.moduleName);
    // Functional component: retornamos una función de render
    return () => renderCell(props.item, props.header);
  },
});
</script>
